import React from 'react';

import { IMilestoneFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';

import { Text } from '../Text';
import { Box } from '../Box';
import RichText from '../RichText';
import { BlockContainer, Column } from '../Layout';

import {
  ColoredLayout,
  StyledImage,
  DisclaimerText,
  ImageColumn
} from './styles';

interface Props extends IMilestoneFields {
  sysId?: string;
}

export function Milestone({
  headingText,
  image,
  bodyCopy,
  disclaimer,
  backgroundColor,
  textColor,
  sysId,
  imageFirst,
  anchorLink
}: Props) {
  const color = textColor === 'white' ? 'white' : 'black';

  return (
    <BlockContainer
      id={anchorLink ?? `milestone-${sysId}`}
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-blockid={`milestone-${sysId}`}
      data-testid="milestone-block"
    >
      <ColoredLayout
        gutter={0}
        color={backgroundColor || ''}
        flexDirection={{
          0: 'column-reverse',
          tablet: imageFirst ? 'row-reverse' : 'row'
        }}
        alignItems="center"
      >
        <Column
          size={{ 0: 10, tablet: 5, max: 4 }}
          flexDirection="column"
          paddingTop={{ 0: 's', tablet: 'xl', desktop: '2xl' }}
          paddingBottom={{ 0: 's', tablet: 'xl', desktop: '2xl' }}
          paddingRight={{ 0: 0, tablet: !imageFirst ? 'l' : 0 }}
          paddingLeft={{ 0: 0, tablet: imageFirst ? 'l' : 0 }}
          justifyContent="center"
        >
          <Box marginBottom="sm">
            <Text
              as="h2"
              fontWeight="h2"
              fontSize={{
                0: 'h2_0',
                tablet: 'h2_tablet',
                desktop: 'h2_desktop'
              }}
              colour={{ 0: 'milestoneText', tablet: color }}
            >
              {headingText}
            </Text>
          </Box>
          {bodyCopy && (
            <Box marginBottom={disclaimer ? 'ml' : 0}>
              <RichText
                bulletColor={color}
                data={bodyCopy}
                colour={{ 0: 'milestoneText', tablet: color, desktop: color }}
              />
            </Box>
          )}
          {disclaimer && (
            <DisclaimerText
              as="p"
              fontSize={{
                0: 'small_p_0',
                desktop: 'small_p_tablet'
              }}
              colour={{ 0: 'milestoneText', tablet: color }}
            >
              {disclaimer}
            </DisclaimerText>
          )}
        </Column>
        <ImageColumn
          size={{ 0: 12, tablet: 5 }}
          color={backgroundColor || ''}
          borderRadius={{ 0: 'block', tablet: '0' }}
          alignSelf="flex-end"
          imageFirst={!!imageFirst}
        >
          <div>
            <StyledImage {...getImageData(image)} />
          </div>
        </ImageColumn>
      </ColoredLayout>
    </BlockContainer>
  );
}
